import { usePoMutation } from '@gov-nx/api/hooks/usePoMutation';
import { zahajAutorizaci } from '@gov-nx/api/queries/authQuery';

interface ZahajAutorizaciQueryProps {
	onSuccess?: (data: Awaited<ReturnType<typeof zahajAutorizaci>>) => void;
}

export const useZahajAutorizaciQuery = (props?: ZahajAutorizaciQueryProps) => {
	const mutation = usePoMutation(
		{
			mutationFn: zahajAutorizaci,
			onSuccess: (data) => {
				props?.onSuccess?.(data);
			},
		},
		{
			errorIgnoreFilter: () => true,
		}
	);

	return mutation;
};
